import { RecordTypes } from '../flatfileConfig'
import { aroParticipantListeners } from './aroParticipantListeners'
import { recordHook } from '@flatfile/plugin-record-hook'
import { bdParticipantListeners } from './bdParticipantListeners'
import { searchServiceListeners } from './searchServiceListeners'
import { parseNumberFromCurrencyValue } from 'utils'
import { uncashedChecksParticipantListeners } from './uncashedChecksParticipantListeners'
import { notificationsParticipantListeners } from './notificationsParticipantListeners'
import { inheritedIraParticipantListeners } from './inheritedIraParticipantListeners'

export const iraAmountValidator = (
  listener,
  sheetSlug,
  fieldsToCheck,
  mainField,
  errorMessage
) => {
  listener.use(
    recordHook(sheetSlug, (record) => {
      const mainValue = record.get(mainField)

      // Check if all specified fields are missing
      const allFieldsMissing = fieldsToCheck.every(
        (field) => !record.get(field)
      )

      // Validate that the main field is present that at least one field is a non-zero value
      if (allFieldsMissing) {
        if (!mainValue) {
          // All fields including main are missing
          record.validate(
            mainField,
            (value) => value !== null && value !== undefined && value !== '',
            errorMessage
          )
        } else {
          // Only main field is filled; throw error if zero
          const parsed = parseNumberFromCurrencyValue(mainValue)
          if (parsed === 0) {
            record.validate(
              mainField,
              (value) => parseNumberFromCurrencyValue(value) !== 0,
              'One of the amounts should not be zero'
            )
          }
        }
      } else if (mainValue) {
        // At least one other field is filled; throw error if all filled fields including main are zero
        const allFields = [mainField, ...fieldsToCheck]
        const filledFields = allFields.filter((field) => record.get(field))
        const allFilledFieldsZero = filledFields.every((field) => {
          const parsed = parseNumberFromCurrencyValue(record.get(field))
          return parsed === 0
        })

        if (allFilledFieldsZero) {
          record.validate(
            mainField,
            (value) => parseNumberFromCurrencyValue(value) !== 0,
            'One of the amounts should not be zero'
          )
        }
      }

      return record
    })
  )
}

export const recordkeeperListener = (listener, sheetSlug) => {
  listener.use(
    recordHook(sheetSlug, (record) => {
      const recordkeeper = record.get('recordkeeper')
      // if recordkeeper field is empty then show custom error message
      if (!recordkeeper) {
        record.addError(
          'recordkeeper',
          'Enter your company name if self-administering.'
        )
      }
      return record
    })
  )
}

export const listeners = {
  [RecordTypes.ARO_PARTICIPANT]: aroParticipantListeners,
  [RecordTypes.BD_PARTICIPANT]: bdParticipantListeners,
  [RecordTypes.SEARCH]: searchServiceListeners,
  [RecordTypes.UCH_PARTICIPANT]: uncashedChecksParticipantListeners,
  [RecordTypes.NOTIF_PARTICIPANT]: notificationsParticipantListeners,
  [RecordTypes.INHERITED_IRA_PARTICIPANT]: inheritedIraParticipantListeners,
}
